/**
 * 防拷贝方案 v46 - 终极混合（复制拦截 + 结构破坏）
 * 核心：不替换字符，而是破坏文本结构，让 AI 无法正确解析
 */

(function() {
  'use strict';

  var CFG = {
    protectedSelectors: ['.technical_specifications', '.optical_data_selector'],
    
    // 结构破坏：在关键位置插入"分隔符"，让 AI 分词出错
    // 用"软连字符"（Soft Hyphen）U+00AD：视觉不可见，但标记可断行位置
    // 豆包可能保留或删除，但会干扰分词
    softHyphen: '\u00AD',
    
    // 用"零宽连接符"（已被豆包删除，不用）
    // 用"从左到右标记"（已被豆包删除，不用）
    
    // 用"窄不间断空格"（Narrow No-Break Space）U+202F
    // 视觉上几乎不可见，但编码不同
    narrowSpace: '\u202F',
  };

  function obfuscate(text) {
    var result = '';
    var words = text.split(/(\s+)/);
    
    for (var w = 0; w < words.length; w++) {
      var word = words[w];
      
      if (/^\s+$/.test(word)) {
        // 空格替换为窄不间断空格
        result += CFG.narrowSpace;
        continue;
      }
      
      // 在单词内部随机插入软连字符
      for (var i = 0; i < word.length; i++) {
        result += word[i];
        if (i > 0 && i < word.length - 1 && Math.random() < 0.4) {
          result += CFG.softHyphen;
        }
      }
    }
    
    return result;
  }

  function isProtected(node) {
    if (!node) return false;
    var el = node.nodeType === 3 ? node.parentNode : node;
    if (!el || !el.closest) return false;
    for (var i = 0; i < CFG.protectedSelectors.length; i++) {
      if (el.closest(CFG.protectedSelectors[i])) return true;
    }
    return false;
  }

  function handleCopy(e) {
    var sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;
    
    var range = sel.getRangeAt(0);
    if (!isProtected(range.commonAncestorContainer)) return;
    
    var text = sel.toString();
    if (!text) return;
    
    var obfuscated = obfuscate(text);
    
    try {
      e.clipboardData.setData('text/plain', obfuscated);
      e.preventDefault();
      console.log('[AntiCopy] v46 - Copied:', JSON.stringify(obfuscated.substring(0, 80)));
    } catch (err) {
      console.error('[AntiCopy] Failed:', err);
    }
  }

  document.addEventListener('copy', handleCopy, true);
  console.log('[AntiCopy] v46 initialized - Soft hyphen + narrow space');

  window.AntiCopy = { obfuscate: obfuscate };
})();
